import { render, staticRenderFns } from "./SetPolicy.vue?vue&type=template&id=5ec1ef6d&"
import script from "./SetPolicy.vue?vue&type=script&lang=js&"
export * from "./SetPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports